exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// ./node_modules/pbkdf2/browser.js
// module id = /vd3
// module chunks = 2